export default {
    mask: {
        class: 'p-dialog-mask fixed inset-0 flex items-center justify-center z-50',
    },
    root: {
        class: 'p-dialog-root max-w-full mx-4 flex flex-col max-h-[90vh]',
    },
    header: {
        class: 'p-dialog-header flex items-center justify-between px-6 py-4',
    },
    title: {
        class: 'p-dialog-title',
    },
    headerActions: {
        class: 'flex items-center',
    },
    pcCloseButton: {
        root: {
            class: 'p-dialog-close w-8 h-8 rounded-full flex items-center justify-center transition-colors',
        },
    },
    content: {
        class: 'px-6 py-4 overflow-y-auto',
    },
    footer: {
        class: 'p-dialog-footer flex items-center justify-end gap-2 px-6 py-4',
    },
};
